module.exports = __webpack_public_path__ + "img/how-icon.8a9800f2.svg";